import { NavigationLink } from '../../../../components/Link/Link';
import styled from 'styled-components';
import { Gray, Shade, Size } from '../../../../constants/styles';
export const StyledLabel = styled.span `
  position: relative;
  display: block;
`;
export const StyledLink = styled(NavigationLink) `
  text-decoration: none;
  white-space: nowrap;
  line-height: 58px;
  z-index: 1;
  font-weight: 300;
  position: relative;
  padding: 0 14px;

  ::before {
    position: absolute;
    background-color: transparent;
    bottom: -6px;
    transform: translateY(6px);
    content: '';
    display: block;
    height: 20px;
    width: 100%;
  }

  & > span::after {
    position: absolute;
    background-color: ${({ theme }) => theme.colorsV2.grayscale.black};
    bottom: ${({ isSearchBarVisible }) => (isSearchBarVisible ? '5px' : '-4px')};
    transform: translateY(6px);
    content: '';
    display: ${({ isActive }) => (isActive ? 'block' : 'none')};
    height: 3px;
    width: 100%;
  }

  &:hover {
    text-decoration: none;
  }
`;
export const ListItem = styled.li `
  list-style: none;
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
  width: 100%;

  &:first-child > ${StyledLink} {
    padding-left: 0;
  }

  &:last-child > ${StyledLink} {
    padding-right: 0;
  }

  &:hover {
    cursor: pointer;

    & > div {
      visibility: ${({ hasPanel }) => (hasPanel ? 'visible' : 'hidden')};
      transform: translate(0px, 0px);
    }

    ${StyledLink}>span::after {
      display: block;
    }
  }
`;
export const List = styled.ul `
  text-decoration: none;
  display: flex;
  height: 60px;
  flex-wrap: wrap;
  row-gap: 10px;
  ${ListItem} {
    width: auto;
  }
`;
const searchBarVisibleCss = (isAutocompleteOpen) => {
    if (isAutocompleteOpen) {
        return `
      ${List} {
        flex-wrap: nowrap;
      }
      top: 82px;
      overflow: visible;
      height: 58px;
    `;
    }
    return '';
};
export const Container = styled.nav `
  background-color: transparent;
  height: 78px;
  width: 100%;
  position: absolute;
  font-size: ${Size.body15};
  top: 2px;
  transition: top 0.3s ease, height 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;

  ${({ isSearchBarVisible }) => searchBarVisibleCss(isSearchBarVisible)}
`;
export const Panel = styled.div `
  position: fixed;
  left: 0;
  width: 100%;
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
  box-shadow: 0 15px 25px rgb(0 0 0 / 20%);
  top: ${({ isSearchBarVisible }) => (isSearchBarVisible ? '162px' : '102px')};
  border-top: 1px solid ${Gray.x200};
  visibility: hidden;
  transform: translate(-10000px, 0px);

  ::after {
    bottom: 0;
    box-shadow: ${Shade.x500};
    content: '';
    display: block;
    height: 5px;
    left: 0;
    position: absolute;
    width: 100%;
  }
`;
//# sourceMappingURL=NavigationBar.styled.js.map